import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8ab6640e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "MossRenderContainer"
};
const _hoisted_2 = {
  class: "ft20"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "如下所示，由 \".\" \"|\" \"-\" 三种元素组合而成10种符号，每组符号对应不同的代码,", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "请你尽可能的记住屏幕中显示的符号特征及相应的代码 ", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "并尽量快尽量准确的根据符号特征选择符号代码。", -1));
const _hoisted_6 = {
  class: "ml16 ft20"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_row = _resolveComponent("el-row");
  const _component_MossSymbol = _resolveComponent("MossSymbol");
  const _component_el_col = _resolveComponent("el-col");
  const _component_MossAnswerOption = _resolveComponent("MossAnswerOption");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "flex items-center justify-center"
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_2, "第" + _toDisplayString($props.data.questionIndex + 1) + "题", 1)]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "flex flex-col mt16"
  }, {
    default: _withCtx(() => [_hoisted_3, _hoisted_4, _hoisted_5]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "flex items-center justify-center mt32"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.mappings, (s, si) => {
      return _openBlock(), _createBlock(_component_el_col, {
        span: 12,
        class: "flex items-center justify-center mt16",
        key: s
      }, {
        default: _withCtx(() => [_createVNode(_component_MossSymbol, {
          symbol: s
        }, null, 8, ["symbol"]), _createElementVNode("span", _hoisted_6, _toDisplayString(si), 1)]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  }), (_openBlock(), _createBlock(_component_el_row, {
    class: "flex items-center justify-center mt64 mb32",
    key: `moss_q_${$props.data.questionIndex}`
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.questions, (q, qi) => {
      return _openBlock(), _createBlock(_component_el_col, {
        span: 6,
        class: "flex flex-col flex items-center justify-center",
        key: q
      }, {
        default: _withCtx(() => [_createVNode(_component_MossAnswerOption, {
          symbol: q,
          review: $props.review ? $props.review.answer.split(',')[qi] : null,
          onSelect: v => $options.onSelect(qi, v)
        }, null, 8, ["symbol", "review", "onSelect"]), $props.reviewMode ? (_openBlock(), _createBlock(_component_el_row, {
          key: 0,
          class: "flex flex-col mt16"
        }, {
          default: _withCtx(() => [_createElementVNode("span", null, "正确答案：" + _toDisplayString($props.data.rightAnswers[qi]), 1), $props.review ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            style: _normalizeStyle({
              color: $props.review.result ? 'green' : 'red'
            })
          }, "您的答案：" + _toDisplayString($props.review.answer.split(',')[qi]), 5)) : _createCommentVNode("", true)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true)]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  }))]);
}